<procure-show-field label="Invited Users">
  @if (users().length) {
    <div class="invited-users">
      @for (user of users(); track user.uuid) {
        <procure-invited-user
          class="invited-users__user"
          [entityType]="entityType()"
          [invitedUser]="user"
          [entityId]="entityId()"
          [canRemove]="canRemove()"
          (remove)="remove.emit()"
        />
      }
    </div>
  } @else {
    -
  }
</procure-show-field>
